import { render, staticRenderFns } from "./TransModal.vue?vue&type=template&id=290c06aa"
import script from "./TransModal.vue?vue&type=script&lang=js"
export * from "./TransModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports